import React from 'react';
import { Box } from '@mui/material';
import logo from '../assets/images/BA-logo-lettersside-bgremoved.png';

export default function Logo({ width = 120, alt = 'BA Logo' }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <img src={logo} alt={alt} style={{ width: width, height: 'auto', display: 'block' }} />
    </Box>
  );
}
